__turbopack_context__.v({
  "body": "WLatestNews-module__AVhxhq__body",
  "date": "WLatestNews-module__AVhxhq__date",
  "empty": "WLatestNews-module__AVhxhq__empty",
  "excerpt": "WLatestNews-module__AVhxhq__excerpt",
  "item": "WLatestNews-module__AVhxhq__item",
  "itemLink": "WLatestNews-module__AVhxhq__itemLink",
  "list": "WLatestNews-module__AVhxhq__list",
  "readMore": "WLatestNews-module__AVhxhq__readMore",
  "root": "WLatestNews-module__AVhxhq__root",
  "thumb": "WLatestNews-module__AVhxhq__thumb",
  "title": "WLatestNews-module__AVhxhq__title",
  "watchAll": "WLatestNews-module__AVhxhq__watchAll",
});
